module.exports = __webpack_public_path__ + "static/media/React.1a035f2f.png";